import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import FiltersMenuContentQuery from './__generated__/FiltersMenuContentQuery.graphql';

export const filtersMenuEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-issue-navigator-filters-menu-entrypoint" */ './FiltersMenuContent.tsx'
			),
	),
	getPreloadProps: ({
		projectId,
		first,
		includeProjectClause,
	}: {
		projectId: string;
		first?: number;
		includeProjectClause?: boolean;
	}) => ({
		queries: {
			mainQuery: {
				parameters: FiltersMenuContentQuery,
				variables: {
					projectId,
					first,
					includeProjectClause,
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
